import React, { useState, useEffect } from 'react';
import { 
  FiMoreVertical, FiCheckCircle, FiXCircle, FiClock, FiEye, 
  FiTrash2, FiToggleLeft, FiEdit, FiClock as FiWatch, 
  FiZap, FiAlertTriangle 
} from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import DropDown from '../../../../app/components/Dropdown';
import { Tabs } from '../../../../app/components/Tabs';
import FormAddAutomations from '../../../../forms/Automations/FormAddAutomations'; 
import FormEditAutomations from '../../../../forms/Automations/FormEditAutomations';
import FormDeleteAutomations from '../../../../forms/Automations/FormDeleteAutomations';
import Button from '../../../../app/components/Button';
import SummaryCard from '../../../../app/components/SummaryCard';
import { usePageTitle } from '../../../../contexts/PageTitleContext';


const departamentos = [
  'Recursos Humanos', 'Comercial', 'Sucesso do Cliente', 'Fiscal', 'DP',
  'Ordens de Serviços', 'Gestão para Resultados', 'Legalização',
  'Gestão de Riscos', 'Financeiro', 'Contábil'
];

const automacoesMock = [
  {
    id: 1,
    nome: 'Admitido - Criar card em base de colaboradores',
    descricao: 'Sem descrição',
    gatilho: 'card_movido',
    acao: 'criar_card',
    departamento: 'Recursos Humanos',
    sequencia: 'Base de Colaboradores',
    fase: 'Ativos',
    filtro: 'N/A',
    status: 'Ativa',
    sucessos: 0,
    falhas: 0,
    ultimaExecucao: 'N/A'
  },
  {
    id: 2,
    nome: '(EMAIL) Aviso de treinamento concluído',
    descricao: 'Sem descrição',
    gatilho: 'card_movido',
    acao: 'enviar_email',
    departamento: 'Recursos Humanos',
    sequencia: 'N/A',
    fase: 'N/A',
    filtro: 'N/A',
    status: 'Ativa',
    sucessos: 5,
    falhas: 0,
    ultimaExecucao: '2025-06-16 19:56'
  },
  {
    id: 3,
    nome: '(EMAIL) Aviso de treinamento rejeitado',
    descricao: 'Sem descrição',
    gatilho: 'card_movido',
    acao: 'enviar_email',
    departamento: 'Recursos Humanos',
    sequencia: 'N/A',
    fase: 'N/A',
    filtro: 'N/A',
    status: 'Inativa',
    sucessos: 0,
    falhas: 0,
    ultimaExecucao: 'N/A'
  },
  {
    id: 4,
    nome: 'Quando admitido - Criar rotina financeira',
    descricao: 'Um card entrar em uma fase na Sequência Banco de talentos > Para a fase admitido > Cria um card na Sequência Rotina financeira',
    gatilho: 'card_movido',
    acao: 'criar_card',
    departamento: 'Recursos Humanos',
    sequencia: 'Rotina financeira',
    fase: 'N/A',
    filtro: 'N/A',
    status: 'Ativa',
    sucessos: 0,
    falhas: 0,
    ultimaExecucao: 'N/A'
  },
  {
    id: 5,
    nome: 'Criação de cliente - Notificar equipe',
    descricao: 'Quando um novo cliente é criado, notificar a equipe comercial',
    gatilho: 'novo_card',
    acao: 'enviar_email',
    departamento: 'Comercial',
    sequencia: 'Entrada de Cliente',
    fase: 'N/A',
    filtro: 'N/A',
    status: 'Ativa',
    sucessos: 3,
    falhas: 0,
    ultimaExecucao: '2025-06-20 14:30'
  },
  {
    id: 6,
    nome: 'Atualização fiscal - Gerar documento',
    descricao: 'Quando dados fiscais são atualizados, gerar documento de comprovação',
    gatilho: 'card_atualizado',
    acao: 'criar_empresa',
    departamento: 'Fiscal',
    sequencia: 'Obrigações Acessórias',
    fase: 'N/A',
    filtro: 'N/A',
    status: 'Ativa',
    sucessos: 12,
    falhas: 2,
    ultimaExecucao: '2025-06-22 09:45'
  }
];

const getDropdownOptions = (automacao, onView, onToggleStatus, onDelete, onEdit) => {
  return [
    {
      icon: FiEye,
      label: "Ver detalhes",
      onClick: () => onView(automacao)
    },
    {
      icon: FiToggleLeft,
      label: automacao.status === 'Ativa' ? 'Desativar' : 'Ativar',
      onClick: () => onToggleStatus(automacao)
    },
    {
      icon: FiEdit,
      label: "Editar",
      onClick: () => onEdit(automacao)
    },
    {
      icon: FiTrash2,
      label: "Excluir",
      onClick: () => onDelete(automacao)
    }
  ];
};

const EmptyCard = ({ departamento }) => (
  <div 
    className="h-full w-full flex flex-col items-center justify-center text-center pt-24 text-sm" 
  >
    <p className="font-medium text-gray-500">Nenhuma automação configurada</p>
  <p className="text-gray-500">Adicione a primeira automação para "{departamento}".</p>
  </div>
);

const StatusBadge = ({ status }) => {
  const isActive = status === 'Ativa';
  
  return (
    <div className={`flex items-center gap-1.5 ${isActive ? 'text-[#34D399]' : 'text-gray-500'}`}>
      <div className={`w-2.5 h-2.5 rounded-full ${isActive ? 'bg-[#34D399]' : 'bg-gray-400'}`}></div>
      <span className="text-xs font-medium">{isActive ? 'Ativa' : 'Inativa'}</span>
    </div>
  );
};

const AutomacaoCard = ({ automacao, onEdit, onDelete, onToggleStatus, onView }) => {
  const gatilhoLabel = {
    'card_movido': 'Card movido',
    'novo_card': 'Novo card',
    'card_atualizado': 'Card atualizado'
  };
  
  const acaoLabel = {
    'criar_card': 'Criar card',
    'enviar_email': 'Enviar email',
    'mover_card': 'Mover card',
    'atualizar_card': 'Atualizar card',
    'criar_empresa': 'Criar empresa',
    'atualizar_empresa': 'Atualizar empresa'
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-5 relative transition-all duration-200 flex flex-col h-full">
      <div className="flex items-start justify-between mb-3">
        <StatusBadge status={automacao.status} />
        <DropDown 
          options={getDropdownOptions(automacao, onView, onToggleStatus, onDelete, onEdit)} 
          trigger={<FiMoreVertical size={16} />}
        />
      </div>
      
      <div className="mb-4">
        <h3 className="text-sm font-medium text-gray-900 mb-1">{automacao.nome}</h3>
        <p className="text-xs text-gray-500 line-clamp-2">{automacao.descricao}</p>
      </div>

      <div className="space-y-2 text-xs text-gray-600 mb-4">
        <div>
          <span className="font-medium">Gatilho:</span> {gatilhoLabel[automacao.gatilho] || automacao.gatilho} | <span className="font-medium">Ação:</span> {acaoLabel[automacao.acao] || automacao.acao}
        </div>
        <div>
          <span className="font-medium">Fase:</span> {automacao.fase} | <span className="font-medium">Sequência:</span> {automacao.sequencia}
        </div>
      </div>

      <div className="flex-grow"></div>

      <div className="flex items-start justify-between pt-3 border-t border-gray-100 mt-auto">
        <div className="flex flex-col gap-1.5">
          <div className="flex items-center text-xs text-[#34D399]">
            <FiCheckCircle className="mr-1.5" size={14} />
            <span>{automacao.sucessos} sucesso{automacao.sucessos !== 1 ? 's' : ''}</span>
          </div>
          <div className="flex items-center text-xs text-red-600">
            <FiXCircle className="mr-1.5" size={14} />
            <span>{automacao.falhas} falha{automacao.falhas !== 1 ? 's' : ''}</span>
          </div>
        </div>
        <div className="flex items-center text-xs text-gray-500 self-end">
          <FiClock className="mr-1.5" size={12} />
          <div>
            <span className="font-medium text-xs">Últ. execução:</span> {automacao.ultimaExecucao}
          </div>
        </div>
      </div>
    </div>
  );
};

const Automations = () => {
  const { setTitle } = usePageTitle();
      
  useEffect(() => {
    setTitle('Automações');
  }, [setTitle]);

  const navigate = useNavigate();
  const [automacoes, setAutomacoes] = useState(automacoesMock);
  const [showNovoModal, setShowNovoModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [activeDept, setActiveDept] = useState(departamentos[0]);
  const [selectedAutomacao, setSelectedAutomacao] = useState(null);

  const estatisticas = {
    horasEconomizadas: "83h",
    automacoesAtivas: "61 / 65",
    falhasCriticas: "15"
  };

  useEffect(() => {
  }, []);

  const handleNovaAutomacao = (departamento = '') => {
    setSelectedAutomacao({
      nome: '',
      descricao: '',
      gatilho: '',
      acao: '',
      departamento: departamento || activeDept,
      sequencia: '',
      fase: '',
      filtro: ''
    });
    setShowNovoModal(true);
  };

  const handleEditAutomacao = (automacao) => {
    setSelectedAutomacao(automacao);
    setShowEditModal(true);
  };

  const handleSaveNovaAutomacao = (formData) => {
    const novaAutomacao = {
      ...formData,
      id: Date.now(),
      status: 'Ativa',
      sucessos: 0,
      falhas: 0,
      ultimaExecucao: 'N/A'
    };
    
    setAutomacoes(prev => [...prev, novaAutomacao]);
    setShowNovoModal(false);
    setSelectedAutomacao(null);
  };

  const handleSaveEditAutomacao = (formData) => {
    setAutomacoes(prev => prev.map(auto => 
      auto.id === formData.id ? formData : auto
    ));
    
    setShowEditModal(false);
    setSelectedAutomacao(null);
  };

  const handleCloseNovoModal = () => {
    setShowNovoModal(false);
    setSelectedAutomacao(null);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedAutomacao(null);
  };

  const handleViewAutomacao = (automacao) => {
    navigate(`/lista-automacoes/${automacao.id}`);
  };

  const handleDeleteAutomacao = (automacao) => {
    setSelectedAutomacao(automacao);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    if (selectedAutomacao) {
      setAutomacoes(prev => prev.filter(auto => auto.id !== selectedAutomacao.id));
      setShowDeleteModal(false);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleToggleStatus = (automacao) => {
    setAutomacoes(prev => prev.map(auto => {
      if (auto.id === automacao.id) {
        return {
          ...auto,
          status: auto.status === 'Ativa' ? 'Inativa' : 'Ativa'
        };
      }
      return auto;
    }));
  };

  const automacoesDepartamento = automacoes.filter(auto => auto.departamento === activeDept);

  return (
    <div>
      <div className="min-h-screen">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-8">
          <SummaryCard 
            icon={FiWatch} 
            title="Horas Economizadas (Mês)" 
            value={estatisticas.horasEconomizadas}
            color="#5B21B6"
          />
          <SummaryCard 
            icon={FiZap} 
            title="Automações Ativas" 
            value={estatisticas.automacoesAtivas}
            color="#34D399"
          />
          <SummaryCard 
            icon={FiAlertTriangle} 
            title="Falhas Críticas" 
            value={estatisticas.falhasCriticas}
            color="#DC2626"
          />
        </div>
        <div className="flex items-center mb-6">
          <Button onClick={() => handleNovaAutomacao()}>
            Nova Automação
          </Button>
        </div>
        <div className="w-full mb-8">
          <Tabs
            tabsName={departamentos}
            activeTabName={activeDept}
            onTabClick={setActiveDept}
            align="left"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-6 max-w-full mx-auto">
          {automacoesDepartamento.length > 0 ? (
            automacoesDepartamento.map((auto) => (
              <AutomacaoCard 
                key={auto.id} 
                automacao={auto} 
                onEdit={handleEditAutomacao}
                onDelete={handleDeleteAutomacao}
                onToggleStatus={handleToggleStatus}
                onView={handleViewAutomacao}
              />
            ))
          ) : (
            <div className="sm:col-span-1 md:col-span-2 lg:col-span-3 xl:col-span-3 2xl:col-span-4">
              <EmptyCard 
                departamento={activeDept} 
                onNovaAutomacao={() => handleNovaAutomacao(activeDept)}
              />
            </div>
          )}
        </div>

        <FormAddAutomations
          isOpen={showNovoModal}
          onClose={handleCloseNovoModal}
          onSubmit={handleSaveNovaAutomacao}
          defaultValues={selectedAutomacao}
        />

        <FormEditAutomations
          isOpen={showEditModal}
          onClose={handleCloseEditModal}
          onSubmit={handleSaveEditAutomacao}
          selectedAutomation={selectedAutomacao}
          title="Editar Automação"
        />

        <FormDeleteAutomations
          isOpen={showDeleteModal}
          onClose={handleCloseDeleteModal}
          onConfirm={handleConfirmDelete}
          automacao={selectedAutomacao}
          itemLabel="automação"
          title="Excluir Automação"
        />
      </div>
    </div>
  );
};

export default Automations;